import styled, { css } from 'styled-components'

export const Content = styled.div(
  ({ theme }) => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${theme.space['16']};
  `,
)

export const PricesContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['8']};
    padding-top: ${theme.space['24']};
  `,
)

export const Price = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['8']};
    color: ${theme.colors.black800};

    & > span {
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 1.5rem;
    }

    &:last-child > span {
      font-size: 2.4rem;
      font-weight: 600;
      line-height: 3.2rem;
    }
  `,
)

export const Controls = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: ${theme.space['8']};
    margin-top: auto;
    padding: ${theme.space['16']};
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadow.marketShopShadow};
  `,
)
